var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"input-styles inputPrice text-center",attrs:{"type":"number","value":_vm.modelValue,"placeholder":"0.00","prefix":"$","hide-details":"","outlined":"","disabled":_vm.disabled},on:{"input":(val) => _vm.setInput(val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }